import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useController, useFormContext } from 'react-hook-form';
import { FormErrorMessage } from '../error-message';
import { PriceInput } from './price';
export const FormPriceInput = ({ name, currency, ...props }) => {
    const { register } = useFormContext();
    const { fieldState } = useController({ name });
    const error = fieldState.error?.message;
    return (_jsxs("div", { className: "flex flex-col gap-stack-dense grow", children: [_jsx(PriceInput, { ...props, ...register(name, { valueAsNumber: true }), currency: currency, error: error }), _jsx(FormErrorMessage, { error: error })] }));
};
